<script setup>
import { deviceStore } from './../stores/deviceStore'
import { ref, onMounted } from 'vue'

const store = deviceStore();

defineProps({
  viewportID: {
    type: String,
    required: true
  }
})

function minimizeLp(viewportID) {
  console.log("minimizeLp Clicked");
  let menuItem = store.getRootmenuByLocalIndex(0);
  if (menuItem) {
    window.BotServices.PullRootMenu(menuItem);
  }
}

const popUp = ref(null)
const showPop = ref(false)

const showSmartTicker = ref(true)
  
const showPopUp = () => {
  showPop.value = true
  const body = document.body
  // body.style.height = '100vh';
  // body.style.overflowY = 'hidden';
}
const closePopUp = () => {

  showPop.value = false
  const body = document.body;
  const scrollY = body.style.top;
  // body.style.position = '';
  // body.style.top = '';
  // body.style.height = '';
  // body.style.overflowY = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

const togglePopUp = () => {
  if (showPop.value == false) {
    showPopUp()
  } else {
    closePopUp()
  }
}
const toggleSmartTicker = () => {
  if (showSmartTicker.value == false) {
    document.dispatchEvent(new Event('showSmartTicker'))
    showSmartTicker.value = true;
  } else {
    document.dispatchEvent(new Event('hideSmartTicker'))
    showSmartTicker.value = false
  }
  closePopUp()
}

onMounted(() => {

  document.querySelectorAll('.simplia-home-menu-item').forEach(item => {
    item.addEventListener('click', event => {
      closePopUp()
    })
  })
  document.addEventListener('toggleSimpliaMenu', () => {
    togglePopUp()
  })
})

</script>

<script>
export default {
  components: {
  },
  data: () => ({
    simpliaLoginModal: null,
    currentDownMenu: 1,
    isSignedIn: false,
    user: null
  }),
  mounted() {
    let token = this.$cookies.get("accessToken");
    this.isSignedIn = !!token;
    this.simpliaLoginModal = document.getElementById('simplia-Signin');
    window.addEventListener('userSignedIn', (e) => {
      console.log(e.detail.user)
      this.user = e.detail.user;
    });
  },
  methods: {
    menuUp() {
      if (this.currentDownMenu == 2) {
        this.$refs.floatTop.style.height = '59px';
        this.$refs.menuPop.style.flexDirection = 'row'
        this.currentDownMenu -= 1
      } else if (this.currentDownMenu == 1) {
        this.$refs.floatTop.style.height = 0;
        this.$refs.menuPop.style.visibility = 'collapse'
        this.currentDownMenu -= 1
      }
    },
    menuDown() {
      if (this.currentDownMenu == 1) {
        this.$refs.floatTop.style.height = '50vh';
        this.$refs.menuPop.style.flexDirection = 'column'
        this.currentDownMenu += 1
      } else if (this.currentDownMenu == 0) {
        this.$refs.floatTop.style.height = '59px';
        this.$refs.menuPop.style.flexDirection = 'row'
        this.$refs.menuPop.style.visibility = 'visible'
        this.currentDownMenu += 1
      }
    },
    openSection(num) {
      this.$emit('open', num);
    },
    showFullscreen: function (viewPort) {
      let fullscreen = document.getElementById(viewPort);
      if (!document.fullscreenElement) {
        fullscreen?.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    exitFullscreen: function (viewPort) {
      let fullscreen = document.getElementById(viewPort);
      document.exitFullscreen();
    },
    modalOpen() {
      this.simpliaLoginModal._instance.exposed.modalOpen()
    },
    showRootMenu() {
      window.showRootMenu();
    },
    showSwitchRole() {
      window.DevMgr.showSwitchRole()
    },
    showChangeRole() {
      const ev = new CustomEvent('showChangeRole', { detail: { user: this.user } })
      window.dispatchEvent(ev)
    },
    signOut() {
      const ev = new CustomEvent('userSignedOut', { detail: { user: this.user } })
      window.dispatchEvent(ev)
    },
    hardRefresh() {
      // post fetch method
      fetch('/CommonServices-0025/CloudFront/Invalidate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          DomainName: window.top.location.hostname,
          Path: '/*'
        })
      }).then(r => {
        alert('The process of invalidating the CloudFront cache is in progress. Please revisit the site after 5 minutes.')
      })
      .catch(e => {
        alert(e.message)
      })
    }
  }
}

</script>

<template>
  <div class="float-top">
    <button style="padding: .25rem 1rem; outline: none;" aria-label="togglePopUpbtn" @click="togglePopUp">
      <i class="fas fa-times" v-if="showPop"></i>
      <i class="fas fa-bars" v-else></i>
    </button>
  </div>
  <!-- POPUP -->
  <div class="main-popup" v-show="showPop">
    <div class="w-full" style="height: 100%">
      <div class="line popup-line"></div>

      <div class="hero-list-text">
        <div ref="menuPop" class="flex flex-wrap p-2 pt-5  text-right top-menu-items">
          <div class="w-1/4 p-1 menu-item">
            <span class="simplia-home-menu-item" @click="showRootMenu"
              style="color: inherit;text-decoration: inherit;cursor:pointer; padding-right: .25rem;">Home
              Menu&nbsp;&nbsp;&nbsp;<i class="mainpanel_option far fa-home navigation-menu"
                style="display:'';cursor: pointer;font-size: 1.1em;"></i>
            </span>
          </div>
          <div class="w-1/4 p-1 menu-item">
            <span class="simplia-home-menu-item" @click="modalOpen()"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;"
              v-if="!isSignedIn">Login/Signup&nbsp;&nbsp;&nbsp;<button title="Login" class="header-button"
                data-original-title="null"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16">
                  <g fill="black">
                    <path
                      d="M384 336c-40.6 0-47.6-1.5-72.2 6.8-17.5 5.9-36.3 9.2-55.8 9.2s-38.3-3.3-55.8-9.2c-24.6-8.3-31.5-6.8-72.2-6.8C57.3 336 0 393.3 0 464v16c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-16c0-70.7-57.3-128-128-128zm80 128H48c0-21.4 8.3-41.5 23.4-56.6C86.5 392.3 106.6 384 128 384c41.1 0 41-1.1 56.8 4.2 23 7.8 47 11.8 71.2 11.8 24.2 0 48.2-4 71.2-11.8 15.8-5.4 15.7-4.2 56.8-4.2 44.1 0 80 35.9 80 80zM256 320c88.4 0 160-71.6 160-160S344.4 0 256 0 96 71.6 96 160s71.6 160 160 160zm0-272c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 48 256 48z">
                    </path>
                  </g>
                </svg></button>
            </span>
            <span class="simplia-home-menu-item" @click="signOut()"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;"
              v-else>Logout&nbsp;&nbsp;&nbsp;<button title="Login" class="header-button" data-original-title="null">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="17">
                  <g fill="black">
                    <path
                      d="M352 146.2L462 256 352 365.8l0-53.8c0-13.3-10.7-24-24-24l-120 0 0-64 120 0c13.3 0 24-10.7 24-24l0-53.8zM512 256c0-11.5-4.6-22.5-12.7-30.6L383.2 109.6c-8.7-8.7-20.5-13.6-32.8-13.6c-25.6 0-46.4 20.8-46.4 46.4l0 33.6-96 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0 0 33.6c0 25.6 20.8 46.4 46.4 46.4c12.3 0 24.1-4.9 32.8-13.6L499.3 286.6c8.1-8.1 12.7-19.1 12.7-30.6zM168 80c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 32C39.4 32 0 71.4 0 120L0 392c0 48.6 39.4 88 88 88l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l80 0z">
                    </path>
                  </g>
                </svg>
              </button>
            </span>
          </div>
          <div class="w-1/4 p-1 menu-item" v-if="isSignedIn">
            <span class="simplia-home-menu-item" @click="showSwitchRole()"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;">Switch
              Role&nbsp;&nbsp;&nbsp;<button title="Minimize" class="header-button" data-original-title="null"><svg
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="18">
                  <g fill="black">
                    <path
                      d="M48 464l300.5 0c12.3 18.8 28 35.1 46.3 48L48 512H0V464 208 160H48l416 0h48v32.7c-5.3-.5-10.6-.7-16-.7c-26.2 0-51.1 5.7-73.4 16L48 208l0 256zM464 80v48L48 128V80l416 0zM416 0V48L96 48V0H416zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L552 416H440l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z" />
                  </g>
                </svg></button></span>
          </div>
          <div class="w-1/4 p-1 menu-item" v-if="!isSignedIn">
            <span class="simplia-home-menu-item" @click="showChangeRole()"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;">Switch
              Role&nbsp;&nbsp;&nbsp;<button title="Minimize" class="header-button" data-original-title="null"><svg
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="18">
                  <g fill="black">
                    <path
                      d="M48 464l300.5 0c12.3 18.8 28 35.1 46.3 48L48 512H0V464 208 160H48l416 0h48v32.7c-5.3-.5-10.6-.7-16-.7c-26.2 0-51.1 5.7-73.4 16L48 208l0 256zM464 80v48L48 128V80l416 0zM416 0V48L96 48V0H416zM352 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224.7 77.7L552 416H440l-24.7 29.7c20.4 21.2 49 34.3 80.7 34.3s60.3-13.2 80.7-34.3zM544 336a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z" />
                  </g>
                </svg></button></span>
          </div>
          <div class="w-1/4 p-1 menu-item">
            <span class="simplia-home-menu-item" @click="minimizeLp(viewportID)"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;">Window
              Mode&nbsp;&nbsp;&nbsp;<button title="Minimize" class="header-button" data-original-title="null"><svg
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="17">
                  <g fill="black">
                    <path
                      d="M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h8c6.6 0 12 5.4 12 12v116h116c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v116H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h116v116c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12zm160 0V352h116c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h8c6.6 0 12-5.4 12-12z">
                    </path>
                  </g>
                </svg></button></span>
          </div>
          <div class="w-1/4 p-1 menu-item">
            <span class="simplia-home-menu-item" @click="hardRefresh"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;">
              Hard Refresh&nbsp;&nbsp;&nbsp;<button title="Hard Refresh" class="header-button" data-original-title="null">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="17">
                  <g fill="black">
                    <path d="M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z"/>
                  </g>
                </svg>
              </button></span>
          </div>
          <div class="w-1/4 p-1 menu-item">
            <span class="simplia-home-menu-item" @click="toggleSmartTicker"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;" v-if="showSmartTicker">
              Hide SmartTicker&nbsp;&nbsp;&nbsp;<button title="Hide SmartTicker" class="header-button" data-original-title="null">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="17">
                  <g fill="black">
                    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zm151 118.3C226 97.7 269.5 80 320 80c65.2 0 118.8 29.6 159.9 67.7C518.4 183.5 545 226 558.6 256c-12.6 28-36.6 66.8-70.9 100.9l-53.8-42.2c9.1-17.6 14.2-37.5 14.2-58.7c0-70.7-57.3-128-128-128c-32.2 0-61.7 11.9-84.2 31.5l-46.1-36.1zM394.9 284.2l-81.5-63.9c4.2-8.5 6.6-18.2 6.6-28.3c0-5.5-.7-10.9-2-16c.7 0 1.3 0 2 0c44.2 0 80 35.8 80 80c0 9.9-1.8 19.4-5.1 28.2zm51.3 163.3l-41.9-33C378.8 425.4 350.7 432 320 432c-65.2 0-118.8-29.6-159.9-67.7C121.6 328.5 95 286 81.4 256c8.3-18.4 21.5-41.5 39.4-64.8L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5zm-88-69.3L302 334c-23.5-5.4-43.1-21.2-53.7-42.3l-56.1-44.2c-.2 2.8-.3 5.6-.3 8.5c0 70.7 57.3 128 128 128c13.3 0 26.1-2 38.2-5.8z"/>
                  </g>
                </svg>
              </button>
            </span>
            <span class="simplia-home-menu-item" @click="toggleSmartTicker"
              style="color: inherit;text-decoration: inherit;font-size:16px;cursor:pointer;" v-else>
              Show SmartTicker&nbsp;&nbsp;&nbsp;<button title="Hide SmartTicker" class="header-button" data-original-title="null">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="17">
                  <g fill="black">
                    <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/>
                  </g>
                </svg>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Floating buttons -->
</template>

<style scoped>
.text-right {
  text-align: right
}

.main-popup {
  background: white;
  z-index: 9999;
  align-self: center;
  display: block;
  position: absolute;
  border: 1px solid #eee;
  right: 5px;
  top: 35px;
}

.float-top {
  position: fixed;
  width: 100%;
  height: 40px;
  /* background-color: #0072c5; */
  z-index: 999;
  top: 0;
  text-align: right;
  color: red;
  /* border-top: 1px solid white; */
}

.top-menu-items {
  padding: 1.25rem !important;
  flex-direction: column;
}

.menu-item {
  align-self: center;
  width: 100% !important;
  padding: .5rem;
  /* color: red; */
}

.header-button {
  padding: 0 5px;
  border: none;
  background: white;
  cursor: pointer;
  font-size: 1.1em;
}

@media only screen and (max-width: 600px) {
  .top-menu-items .menu-item {
    font-size: 16px !important;
  }
}

@media only screen and (min-width: 768px) {
  .top-menu-items .menu-item {
    font-size: 16px !important;
  }
}
</style>
